import { render } from "./transportatonContrac.vue?vue&type=template&id=66c4eadd"
import script from "./transportatonContrac.vue?vue&type=script&lang=js"
export * from "./transportatonContrac.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__